module.exports = __webpack_public_path__ + "img/d-refinarias.32d9c035.png";